@if (instance.location.rasterLocation) {
  <span>
    <zenith-icon icon-name="depot" class="mr-1"></zenith-icon>
    {{ instance.location.rasterLocation }}
  </span>
} @else if (instance.location.type) {
  <span>
    {{ ('components.instance.location.' + this.instance.location.type) | translate }}
  </span>
} @else {
  <!-- Show nothing -->
}
